import { useNavigate } from "react-router-dom";
import { mdiAccountOutline, mdiChevronLeft } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";

import { routes } from "constants/routes";
import styles from "./style.module.scss";

interface IProps {
  label: string;
  className?: string;
  canGoBack?: boolean;
  goBackPath?: string;
  headerIcon?: React.ReactNode;
  wrapperClass?: string;
  onClickIconButton?: () => void;
  isHideDesktop?: boolean;
}

export default function Header({
  label,
  className,
  canGoBack = true,
  goBackPath,
  headerIcon,
  wrapperClass,
  onClickIconButton,
  isHideDesktop = false
}: Readonly<IProps>) {
  const navigate = useNavigate();

  const goToUserSettings = () => {
    navigate(routes.SETTINGS);
  };

  function goBack() {
    goBackPath ? navigate(goBackPath) : navigate(-1);
  }

  return (
    <div className={clsx(styles.smartHeader, isHideDesktop && "desktop:hidden", wrapperClass)}>
      {canGoBack ? (
        <button id="header-back-btn" aria-label="Go back" onClick={goBack}>
          <Icon path={mdiChevronLeft} className="size-8" />
        </button>
      ) : null}
      <h4 className={clsx("text-2xl desktop:text-xl font-medium", className)}>{label}</h4>
      <button className={styles.smartHeaderAvatar} onClick={onClickIconButton || goToUserSettings}>
        {headerIcon || <Icon path={mdiAccountOutline} />}
      </button>
    </div>
  );
}
